import { parse } from 'query-string';
import { useConnect } from '@lore/query-connect';
import useNetwork from '@/hooks/useNetwork';

export default function useQuery(props) {
  const {
    location = {},
    PAGE_SIZE = 0, // 0 = count only: server returns metadata but no record data
    returnCsvQuery = false } = props;

  const network = useNetwork();

  const query = {
    where: {
      filter: { intent: 'educator', networkId: network?.id, created: { value: 1, operator: 'at least' } },
    },
    pagination: returnCsvQuery ? undefined : {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc',
    }
  };

  const result = useConnect('user.find', query, {
    enabled: !returnCsvQuery,
    keepPreviousData: true
  });

  if (returnCsvQuery) {
    return query;
  }

  return result;
}
